'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../IconSvg/index.js');
var files = require('../../../images/files.svg.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var UploadImage = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(UploadImage, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(UploadImage);

  function UploadImage(props) {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, UploadImage);

    _this = _super.call(this, props);

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDragEnter", function () {
      _this.setState({
        isDragOver: true
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onDragLeave", function () {
      _this.setState({
        isDragOver: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onChange", function () {
      var file = _this.inputRef.current.files[0];

      var isValid = _this.getIsValid(file);

      _this.setState({
        isUploading: true,
        errorText: undefined,
        isError: false
      });

      if (!isValid.error) {
        _this.onUploadFile(file);
      } else {
        _this.onError(isValid.errorText);

        _this.resetInput();
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onRemoveFile", function () {
      var onChange = _this.props.onChange;

      _this.setState({
        errorText: undefined,
        isDragOver: false,
        isError: false,
        isUploading: false,
        uploadedFile: undefined
      });

      _this.resetInput();

      onChange(undefined);
    });

    var currentFile = props.currentFile;
    _this.state = {
      errorText: undefined,
      isDragOver: false,
      isError: false,
      isUploading: false,
      uploadedFile: currentFile
    };
    _this.inputRef = React__default['default'].createRef();
    return _this;
  }

  _rollupPluginBabelHelpers.createClass(UploadImage, [{
    key: "onUploadFile",
    value: function onUploadFile(file) {
      var _this2 = this;

      var onUploadFile = this.props.onUploadFile;
      onUploadFile(file).then(function (_ref) {
        var error = _ref.error,
            errorText = _ref.errorText,
            uploadedFile = _ref.uploadedFile;
        var onChange = _this2.props.onChange;

        if (error || !uploadedFile) {
          _this2.onError(errorText);
        } else {
          _this2.setState({
            errorText: undefined,
            isDragOver: false,
            isError: false,
            isUploading: false,
            uploadedFile: uploadedFile
          });

          onChange(uploadedFile.url);
        }

        _this2.resetInput();
      });
    }
  }, {
    key: "onError",
    value: function onError(errorText) {
      this.setState({
        errorText: errorText,
        isError: true,
        isDragOver: false,
        isUploading: false
      });
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var className = this.props.className;
      var _this$state = this.state,
          isError = _this$state.isError,
          isDragOver = _this$state.isDragOver,
          isUploading = _this$state.isUploading,
          uploadedFile = _this$state.uploadedFile;
      var finalClassName = "ds-atom-upload-image ".concat(className);

      if (isDragOver) {
        finalClassName += ' dragging';
      }

      if (isUploading) {
        finalClassName += ' loading';
      }

      if (isError) {
        finalClassName += ' file-error';
      }

      if (uploadedFile) {
        finalClassName += ' filled';
      }

      return finalClassName;
    }
  }, {
    key: "getIsValid",
    value: function getIsValid(file) {
      var onCheckIsValid = this.props.onCheckIsValid;
      return !onCheckIsValid ? {
        error: false
      } : onCheckIsValid(file);
    }
  }, {
    key: "resetInput",
    value: function resetInput() {
      this.inputRef.current.value = null;
    }
  }, {
    key: "renderDefault",
    value: function renderDefault() {
      var _this$props = this.props,
          descriptionLeft = _this$props.descriptionLeft,
          descriptionRight = _this$props.descriptionRight,
          disclaimer = _this$props.disclaimer,
          image = _this$props.image;
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, image && /*#__PURE__*/React__default['default'].createElement("img", {
        src: image,
        alt: "upload-icon"
      }), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-upload-image-description"
      }, descriptionLeft, " ", /*#__PURE__*/React__default['default'].createElement("span", null, descriptionRight)), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-upload-image-disclaimer"
      }, disclaimer));
    }
  }, {
    key: "renderDrag",
    value: function renderDrag() {
      var dropMessage = this.props.dropMessage;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-upload-image-drop-message"
      }, dropMessage);
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React__default['default'].createElement(index, {
        className: "ds-atom-btn-spinner-circle",
        icon: "spinner"
      });
    }
  }, {
    key: "renderUploadedFile",
    value: function renderUploadedFile() {
      var uploadedFile = this.state.uploadedFile;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-upload-image-uploaded",
        style: uploadedFile.type === 'image' ? {
          backgroundImage: "url('".concat(uploadedFile.url, "')")
        } : {}
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        className: "ds-atom-upload-image-uploaded-remove",
        onClick: this.onRemoveFile,
        type: "button"
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        icon: "delete"
      })));
    }
  }, {
    key: "renderErrorText",
    value: function renderErrorText() {
      var errorText = this.state.errorText;
      return errorText && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "ds-atom-upload-image-error-text"
      }, errorText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isError = _this$state2.isError,
          isDragOver = _this$state2.isDragOver,
          isUploading = _this$state2.isUploading,
          uploadedFile = _this$state2.uploadedFile;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: this.getClassName()
      }, /*#__PURE__*/React__default['default'].createElement("input", {
        className: "ds-atom-upload-image-input",
        id: "ds-atom-upload-image",
        name: "files[]",
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onChange: this.onChange,
        ref: this.inputRef,
        type: "file"
      }), uploadedFile ? this.renderUploadedFile() : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !isUploading && !isDragOver && this.renderDefault(), !isUploading && isDragOver && this.renderDrag(), isUploading && this.renderLoading(), !isDragOver && isError && this.renderErrorText()));
    }
  }]);

  return UploadImage;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(UploadImage, "propTypes", {
  className: PropTypes__default['default'].string,
  currentFile: PropTypes__default['default'].shape({
    type: PropTypes__default['default'].string,
    url: PropTypes__default['default'].string
  }),
  descriptionLeft: PropTypes__default['default'].string,
  descriptionRight: PropTypes__default['default'].string,
  disclaimer: PropTypes__default['default'].string,
  dropMessage: PropTypes__default['default'].string,
  image: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func.isRequired,
  onCheckIsValid: PropTypes__default['default'].func,
  onUploadFile: PropTypes__default['default'].func.isRequired
});

_rollupPluginBabelHelpers.defineProperty(UploadImage, "defaultProps", {
  className: '',
  currentFile: undefined,
  descriptionLeft: '',
  descriptionRight: '',
  disclaimer: '',
  dropMessage: '',
  image: files,
  onCheckIsValid: undefined
});

module.exports = UploadImage;
